import React, { Component } from 'react'
import { checkTranslation, imageAddress, translate } from '../../../../utils/useful'
import FixedView from '../../../FixedView'
import SwitchInput from '../../../inputs/SwitchInput'
import SidebarView from '../../../SidebarView'
import Members from '../sideBar/Members'
import StagesManager from '../../../StagesManager'
import ContactInfoFirst from './ContactInfoFirst'
import ContactMedia from './ContactMedia'
import SwitchStyle1 from '../../../useful/SwitchButton'




export default class TopicInfo extends Component {
    state = {
        showCollapse: null,
        active: false,
        selected: 0,
        checkBox: {},
        show: false,
        option: [
            // { icon: "/assets/icons/manage-gray.svg", title: "Edit Contact", color: "#444", key: "manage" },
            // { icon: "/assets/icons/messenger/share-contact.svg", title: "Share Contact", color: "#444", key: "share" },
            { icon: "/assets/icons/messenger/block.svg", title: "{{lang}}messenger.Block User", color: "#E61515", key: "block" },
        ],
        contactUser: {},
        userinfo: { username: "@Gedrich98", des: "this is a test bio description that's it the rest is just a usless words just to make this test a little bit longer for testing the UI.", number: "+989021377118" }
    }
    componentDidMount() {
        console.log('pvkss', this.props.messenger)
        this.sidebarView.openSidebar()
        let contactUser = {}
        this.props.messenger?.users.forEach(user => {
            console.log('user mess', user)
            if (this.props.myId != user.hub._id) {
                console.log('contactUser', user)
                console.log(this.props.myId)
                contactUser.username = user.hub?.username
                contactUser.fullname = user.hub?.fullname
                contactUser.phone = user.hub?.phone
                contactUser.image = user.hub?.image
            }
        });
        this.setState({ contactUser })
    }


    openSidebar = () => {
        this.sidebarView.openSidebar()
    }

    openFirstView = () => {
        this.firstView.showView()
    }

    openMemberView = () => {
        this.memberView.showView()
    }
    onClosed = () => {
        setTimeout(() => {
            this.props.setData('messengerInfo', !this.props.messengerInfo, 'Messenger')
        }, 200);
    }


    render() {
        let type = this.state.type
        return (
            <div className='w-100 h-100'>
                <SidebarView onClosed={this.onClosed} hight={"100%"} width={this.props.width} hideOverlay={false} ref={el => this.sidebarView = el} widthCondition={{ xs: "100%", sm: "100%", md: '35%', lg: "35%", xl: "25%" }}>
                    <div className='h-100' >
                        <div className='flexcb py-3 px-3' style={{ height: '60px', borderBottom: "1px solid #eee", zIndex: 10 }} ref={el => this.firstCurrentNode = el}>
                            <p className='text-bold text-small' style={{}}>{translate('messenger.Topic Info')}</p>
                        </div>
                        <div className='scroll-no-scrollbar' style={{ height: 'calc(100% - 60px)' }}>
                            <div className='flexc px-3 py-3' style={{ borderBottom: "1px solid #eee", }}>
                                <div>
                                    <img className='br-50 flexcc' width={50} height={50} style={{ objectFit: "cover" }} src={imageAddress(this.props.messenger?.image, 'group')} />
                                </div>
                                <div className='mld-4'>
                                    <p className='font-size-16 weight-600 main-c4' style={{}}>{this.props.messenger['**name']}</p>
                                    <p className='font-size-12 weight-300 main-c7' style={{}}>{this.props.messenger?.users?.length} {translate('messenger.members')}</p>
                                </div>
                            </div>
                            {/* {console.log('this.props.topiiiiiiiiiiiiic', this.props)} */}
                            <div>
                                <div className='flexcb w-100 px-3 py-3' style={{ borderBottom: "1px solid #eee" }}>
                                    <div className='flexcb w-100'>
                                        <div className='flexc'>
                                            <img width={22} className='flexcc' src='/assets/icons/messenger/notification-blue.svg' />
                                            <p className='mld-3 font-size-14' style={{ color: "#444" }}>{translate('messenger.Notification')}</p>
                                        </div>
                                        <button className='flexcc'>
                                            <SwitchStyle1 />
                                        </button>
                                    </div>
                                </div>
                                <div className=' px-2 py-2' style={{ borderBottom: "1px solid #eee" }}>
                                    <button className='flexcb w-100 hover-gray p-2 br-5' onClick={() => this.props.changeStage('media')}>
                                        <div className='flexc'>
                                            <img width={22} className='flexcc' src='/assets/icons/messenger/media-blue.svg' />
                                            <p className='mld-3 font-size-14' style={{ color: "#444" }}>{translate('messenger.Media')}</p>
                                        </div>
                                        <div className='flexcc'>
                                            <img width={22} className='rtl-button' src='/assets/icons/arrow-right-blue.svg' />
                                        </div>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </SidebarView>
            </div>
        )
    }
}
